import React, { useState } from "react";

const DateTime = ({
  onValueBlur,
  minDate,
  label,
  name,
  value,
  onValueChange,
  required = false,
}) => {
  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    onValueChange(name, value);
  };
  const handleFocus = (e) => {
    e.target.classList.add("border-[#7ddbff]");
  };

  const handleBlur = (e) => {
    e.target.classList.remove("border-[#7ddbff]");
    const { name, value } = e.target;
    if (onValueBlur) {
      onValueBlur(name, value);
    }
    if (required && !value) {
      //setError("Field is required");
    } else {
      setError("");
    }
  };
  const [error, setError] = useState("");
  return (
    <div className="relative mx-auto lg:min-w-[200px] w-full">
      {label && (
        <div className="py-1">
          <label className="text-start font-roboto font-[400] text-[14px]">
            {label}
          </label>
        </div>
      )}
      <div className="relative flex items-center">
        <input
          type="date"
          id="date"
          name={name}
          min={minDate}
          onChange={handleChangeDate}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required={required}
          className="block w-full px-3 py-2   outline-none
          border-2 !bg-[#7ddbff] !bg-opacity-[30%] rounded-md 
              text-gray-900 text-sm"
        />
      </div>
      {error && (
        <div className="text-red-500 text-xs mt-1  text-start px-2">
          {error}
        </div>
      )}
    </div>
  );
};

export default DateTime;
